const resource = {
    resource_identifier_in_use: '接口标识符 {{indicator}} 已被使用',
    cannot_delete_management_api: '无法删除Logto管理接口。',
    cannot_modify_management_api: '无法修改Logto管理接口。',
};
export default Object.freeze(resource);
